import { ASSIGN_USERS_LIST, ASSIGN_USERS_LIST_SUCCESS, ASSIGN_USERS_LIST_ERROR, DELETE_HANDSET_LIST_ERROR, DELETE_HANDSET_LIST_SUCCESS, DELETE_HANDSET_LIST, UPDATE_HANDSET_LIST_ERROR, UPDATE_HANDSET_LIST_SUCCESS, UPDATE_HANDSET_LIST, ADD_HANDSET_LIST_DETAILS_ERROR, ADD_HANDSET_LIST_DETAILS_SUCCESS, ADD_HANDSET_LIST_DETAILS, HANDSET_LIST_DETAILS_ERROR, HANDSET_LIST_DETAILS_SUCCESS, HANDSET_LIST_DETAILS, HANDSET_LIST_ERROR, HANDSET_LIST_SUCCESS, HANDSET_LIST } from './constants';
export default function handsetstatusReducer(state, action) {
	let handsetstatus = [];
	let  users = [];

	switch (action.type) {
	case HANDSET_LIST:
		return { ...state, pending: true };
      
	case HANDSET_LIST_SUCCESS:
        
		if (action.payload && action.payload.data.length > 0) {
			action.payload.data.map( (item) => {
            
				let data = {};

				data.id = item.id ? item.id : 0;
				data.name = item.name ? item.name : '';
				data.simNumber = item?.simNumber? item?.simNumber : ''; 
				data.batteryPercentage = item.batteryPercentage ? item.batteryPercentage : 0;
				data.gsmStrength = item?.gsmStrength? item?.gsmStrength : null;
				data.imeiNumber = item.imeiNumber ? item.imeiNumber : '';
				data.status = item.status ? item.status : '';
				data.pipelineId = item.pipelineId ? item.pipelineId : 0;
				data.assignedUserId = item.assignedUserId ? item.assignedUserId : '';
				data.assignedUser = item.users ? item.users.firstName + ' ' + item.users.lastName : 'No Data' ;
				data.allocationId = item.allocationId ? item.allocationId : null;
				data.allocation = item?.userallocation ? item?.userallocation  && Array.isArray(item?.userallocation) ?  item?.userallocation.map((region)=>(region.regioninfo.regionName+'(' + region.pipelineConfigFrom+' - '+region.pipelineConfigTo + ')')) : `${item?.userallocation?.regioninfo.regionName+'(' + item?.userallocation?.pipelineConfigFrom+' - '+item?.userallocation?.pipelineConfigTo + ')'}` : 'No Data';


				return handsetstatus.push(data);
			});
          
			return { ...state, handsetstatus: handsetstatus, pending: false, error: false };
		} else {
			if (action.payload && action.payload.data.length === 0) {
				return { ...state, handsetstatus: [], pending: false, error: false };
			} else {
				return { ...state, pending: false, error: true };
			}
		}
      
	case HANDSET_LIST_ERROR:
		return { ...state, pending: false, error: true };

	case HANDSET_LIST_DETAILS:
		return { ...state, pending: true };

	case HANDSET_LIST_DETAILS_SUCCESS:
		return { ...state, details: action.payload, pending: false, error: false };

	case HANDSET_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case ADD_HANDSET_LIST_DETAILS:
		return { ...state, pending: false };

	case ADD_HANDSET_LIST_DETAILS_SUCCESS:
		return { ...state, pending: false, error: false };

	case ADD_HANDSET_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case UPDATE_HANDSET_LIST:
		return { ...state, pending: false };

	case UPDATE_HANDSET_LIST_SUCCESS:
		return { ...state, pending: false, error: false };

	case UPDATE_HANDSET_LIST_ERROR:
		return { ...state, pending: false, error: true };
      
	case DELETE_HANDSET_LIST:
		return { ...state, pending: false };

	case DELETE_HANDSET_LIST_SUCCESS:
		return { ...state, pending: false, error: false };

	case DELETE_HANDSET_LIST_ERROR:
		return { ...state, pending: false, error: true };

	case ASSIGN_USERS_LIST:
		return { ...state, pending: true };
      
	case ASSIGN_USERS_LIST_SUCCESS:
        
		if (action.payload && action.payload.data.length > 0) {
			action.payload.data.map( (item) => {
            
				let data = {};

				data.value = item.id ? item.id : 0;
				data.label = item.firstName + ' ' + item.lastName;



				return users.push(data);
			});
          
			return { ...state, users : users, pending: false, error: false };
		} else {
			if (action.payload && action.payload.length === 0) {
				return { ...state, users : users , pending: false, error: false };
			} else {
				return { ...state, pending: false, error: true };
			}
		}
      
	case ASSIGN_USERS_LIST_ERROR:
		return { ...state, pending: false, error: true };

	

	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}